import { AsyncPipe } from '@angular/common'
import { Component, ElementRef, inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { ICON } from '@app/cnst/icons.cnst'
import { SocialModal } from '@app/modals/social/social.modal'
import { Message } from '@app/model/message.model'
import { BaseModal } from '@app/pages/base.modal'
import { confettiService } from '@app/srv/confetti.service'
import { runOutsideAngular } from '@app/srv/di.service'
import { markdownService } from '@app/srv/markdown.service'
import { Priority } from '@app/srv/popup.cnst'
import { PopupController } from '@app/srv/popup.controller'
import { select } from '@app/srv/store.service'
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonLabel,
  IonTitle,
  IonToolbar,
  Platform,
} from '@ionic/angular/standalone'
import { LANG, MediaType, MessageStyle } from '@naturalcycles/shared'
import { CyclerStatusComponent } from '../../cmp/cycler-status/cycler-status.component.js'
import { CyclerStatusPipe } from '../../pipes/cyclerStatus.pipe.js'
import { MarkdownPipe } from '../../pipes/markdown.pipe.js'
import { SafePipe } from '../../pipes/safe.pipe.js'
import { StripTagsPipe } from '../../pipes/strip-tags.pipe.js'

@Component({
  selector: 'page-message-modal',
  templateUrl: './message.modal.html',
  styleUrls: ['./message.modal.scss'],
  imports: [
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonIcon,
    IonTitle,
    CyclerStatusComponent,
    IonContent,
    IonFooter,
    IonLabel,
    AsyncPipe,
    CyclerStatusPipe,
    MarkdownPipe,
    SafePipe,
    StripTagsPipe,
  ],
})
export class MessageModal extends BaseModal implements OnInit, OnDestroy {
  className = 'MessageModal'

  protected markdownService = markdownService
  private platform = inject(Platform)
  private popupController = inject(PopupController)

  @ViewChild('confetti')
  private el!: ElementRef

  @Input({ required: true })
  public message!: Message

  protected lang$ = select(s => s.ui.lang)

  protected cyclerStatus!: number

  protected readonly MediaType = MediaType
  protected readonly MessageStyle = MessageStyle
  protected readonly LANG = LANG
  protected readonly ICON = ICON

  protected isCapacitor = this.platform.is('hybrid')

  public ngOnInit(): void {
    this.cyclerStatus = parseInt(this.message.msgKey.replaceAll(/\D/g, '')) // remove all non-numbers

    void import('@app/srv/confetti.service').then(({ confettiService }) => {
      runOutsideAngular(() => void confettiService.addConfetti(this.el.nativeElement))
    })
  }

  protected shareCyclerStatus(): void {
    const imageURL = `https://assets.naturalcycles.com/images/cycler_status/cyclerstatus-${this.cyclerStatus}.png`
    void this.popupController.presentModal(
      {
        component: SocialModal,
        componentProps: {
          msgKey: this.message.msgKey,
          image: imageURL,
          url: imageURL,
        },
      },
      `modal-social-${this.message.msgKey}`,
      Priority.IMMEDIATE,
    )
  }

  override ngOnDestroy(): void {
    confettiService.reset()
  }
}
